export var createRule = function (x, y, z) {
    return {
        rule: new RegExp(x, "gim"),
        result: y,
        message: z
    };
};
/* tslint:disable */
export var ValidateChannelRules = [
    createRule("(?![a-zA-Z0-9.*_]).", null, "Name cannot contain symbols other than [a-zA-Z0-9.*_]"),
    createRule("^[0-9]", null, "Name cannot start with symbols [0-9]"),
    createRule("\\.$", null, "Name cannot end in '.'")
];
/* tslint:enable */
export var ValidateChannelSchemaError = function (x, y) { return "Channel name: \"" + x + "\" doesn't match naming rule/s:\n => " + y.map(function (z) { return z.message; }).join("\n => "); };
export function validateChannel(x) {
    if (x.length === 0) {
        throw new Error("Cannot use empty string as channel name!");
    }
    var y = ValidateChannelRules.filter(function (r) { return r.result !== x.match(r.rule); });
    if (y.length > 0) {
        throw new Error(ValidateChannelSchemaError(x, y));
    }
    return true;
}
//# sourceMappingURL=validateChannel.js.map